var _style, _path, _path2, _g, _g2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLedere(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ledere",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.2;fill:#777775;}\r\n\t.st1{fill:#777775;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.2,52.2c-2,2.1-4.4,3.7-7.1,4.7c3.5,2.2,6.4,5.3,8.2,8.9h2.6c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3 h-1.5c0.6,1.7,1,3.4,1.2,5.2h8.2c0.7,0,1.3-0.6,1.3-1.3C85,63.5,79.9,55.8,72.2,52.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.4,27.4c8.7,0,15.7,7,15.7,15.7c0,3.8-1.4,7.4-3.7,10.1c0.2,0.7,0.4,1.3,0.7,1.8c7.1-1.5,12.5-7.8,12.5-15.4 c0-8.7-7-15.7-15.7-15.7c-3.7,0-7.1,1.3-9.8,3.4C49.2,27.4,49.3,27.4,49.4,27.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 47.3,
    cy: 43.7,
    r: 15.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.6,56.3c-3.3,3.5-8.1,5.8-13.3,5.8c-5.2,0-10-2.2-13.3-5.8c-7.7,3.6-12.9,11.3-12.9,20.2 c0,0.7,0.6,1.3,1.3,1.3h49.7c0.7,0,1.3-0.6,1.3-1.3C73.4,67.6,68.3,59.8,60.6,56.3z M64.3,72.5h-5.2c-0.7,0-1.3-0.6-1.3-1.3 s0.6-1.3,1.3-1.3h5.2c0.7,0,1.3,0.6,1.3,1.3S65,72.5,64.3,72.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 48.2,
    cy: 42.8,
    r: 15.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.5,55.3c-3.3,3.5-8.1,5.8-13.3,5.8c-5.2,0-10-2.2-13.3-5.8C27.2,58.9,22,66.7,22,75.5 c0,0.7,0.6,1.3,1.3,1.3h49.7c0.7,0,1.3-0.6,1.3-1.3C74.4,66.7,69.2,58.9,61.5,55.3z M65.2,71.6H60c-0.7,0-1.3-0.6-1.3-1.3 S59.3,69,60,69h5.2c0.7,0,1.3,0.6,1.3,1.3S65.9,71.6,65.2,71.6z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.1,51.3c-2,2.1-4.4,3.7-7.1,4.7c3.5,2.2,6.4,5.3,8.2,8.9h2.6c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3 h-1.5c0.6,1.7,1,3.4,1.2,5.2h8.2c0.7,0,1.3-0.6,1.3-1.3C86,62.6,80.8,54.8,73.1,51.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.4,26.4c8.7,0,15.7,7,15.7,15.7c0,3.8-1.4,7.4-3.7,10.1c0.2,0.7,0.4,1.3,0.7,1.8c7.1-1.5,12.5-7.8,12.5-15.4 c0-8.7-7-15.7-15.7-15.7c-3.7,0-7.1,1.3-9.8,3.4C50.1,26.4,50.3,26.4,50.4,26.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedere);
export default __webpack_public_path__ + "static/media/Ledere.0e14884fd1d4a3566db7229ac0d559da.svg";
export { ForwardRef as ReactComponent };